import React, { useState } from 'react';

import cx from 'classnames';

import { ReactComponent as ArrownDownIcon } from 'pages/Teachers/Assignments/CreateMath/assets/arrow-down-icon.svg';
import { ReactComponent as CheckIcon } from 'pages/Teachers/Assignments/CreateMath/assets/check-icon.svg';

import styles from './styles.module.scss';

const RubricSelector = ({
  options,
  selected,
  onSelect,
  placeholder = 'Select a grading rubric...',
  maxGrade = 100,
  onMaxGradeChange
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleMaxGradeChange = (e) => {
    const numericValue = e.target.value.replace(/\D/g, '');
    if (onMaxGradeChange) {
      onMaxGradeChange(numericValue);
    }
  };

  return (
    <div className={styles.fieldSection}>
      <div className={styles.fieldLabel}>
        <span>Grading Rubric</span>
      </div>
      <div className={styles.customSelect} onClick={toggleDropdown}>
        <div className={styles.selectedRubricText}>
          {selected ? (
            <>
              <span className={styles.rubricLabel}>{selected.text}</span>
              {selected.subtext && (
                <span className={styles.rubricSubtext}>{selected.subtext}</span>
              )}
            </>
          ) : (
            <span className={cx(styles.rubricLabel, styles.placeholderText)}>
              {placeholder}
            </span>
          )}
        </div>

        <ArrownDownIcon className={styles.chevron} />

        {isOpen && (
          <div className={styles.rubricDropdownOptions}>
            {options.map((opt) => {
              const isSelected = selected?.key === opt.key;

              return (
                <div
                  key={opt.key}
                  className={cx(styles.rubricOption, {
                    [styles.selected]: isSelected
                  })}
                  onClick={(e) => {
                    e.stopPropagation();
                    onSelect(opt);
                    toggleDropdown(); // Close dropdown after selection
                  }}
                >
                  <div className={styles.checkWrapper}>
                    {isSelected && <CheckIcon className={styles.checkIcon} />}
                  </div>
                  <div className={styles.itemContent}>
                    <span className={styles.optLabel}>{opt.text}</span>
                    {opt.subtext && (
                      <span className={styles.optSubtext}>{opt.subtext}</span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {selected?.key === options[6].key && (
        <div className={styles.maxGradeSection}>
          <div className={styles.fieldLabel}>
            <span>Max Grade Value</span>
          </div>
          <input
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            className={styles.maxGradeInput}
            value={maxGrade}
            onChange={handleMaxGradeChange}
            placeholder="100"
          />
        </div>
      )}
    </div>
  );
};

export default RubricSelector;
